module.exports = __webpack_public_path__ + "img/eight3Green.31b81fa9.jpg";